/**
 * @typedef {{ title, titleColor: "red" | "green", body, footer, width: number, withPassword }} ModalOptions
 */
import "../../styles/scaffold/scaffold.css";
import ReactDOM from "react-dom";
import React, { useState } from "react";
import { Button } from "./buttons";

/**
 * @param {ModalOptions} options 
 */
export function showModal(options, controller = {}) {
    return new Promise(resolve => {
        const onClose = (...args) => {
            ReactDOM.unmountComponentAtNode(modalContainer);
            
            if(args.length > 0) resolve(...args);
            else resolve();
        };

        controller.close = onClose;

        const modalContainer = document.querySelector(".modals");
        const modal = <Modal width={options.width} className={options.className} flexible={options.flexible} titleColor={options.titleColor} title={options.title} body={options.body} footer={options.footer} onClose={onClose} withPassword={options.withPassword} />;
        ReactDOM.render(modal, modalContainer);
    });
}

export function showConfirmationModal({ title, body, affirmText = "YES", declineText = "NO" }) {
    return new Promise(async resolve => {
        const controller = {};
        const confirm = () => {
            resolve(true);
            controller.close();
        };

        const decline = () => {
            resolve(false);
            controller.close();
        };

        await showModal({ title, body, footer: 
            <div className="confirmation-footer">
                <Button onClick={decline}>{declineText}</Button>
                <Button onClick={confirm}>{affirmText}</Button>
            </div>
        }, controller);

        resolve(false);
    });
}

export function Modal({ title, className, flexible, titleColor, width, body, footer, withPassword, onClose, affirmText = "CONFIRM" }) {
    const passwordRef = React.createRef();
    const [ passwordEmpty, setPasswordEmpty ] = useState(true);
    const onPasswordChange = (event) => {
        setPasswordEmpty(event.target.value.trim().length === 0);
    };
    
    const onPasswordSubmit = (event) => {
        event.preventDefault();
        closeWithPassword();
    };

    const closeWithPassword = (event) => {
        event.preventDefault();
        const password = passwordRef.current.value.trim();
        if(password) onClose({ password });
    };

    const modalStyle = {};

    if(width) {
        modalStyle.maxWidth = "none";
        modalStyle.width = width + "px";
    }

    return <div className={"modal" + ( flexible ? " flexible" : "") + " " + ( className || "" )} style={modalStyle}>
        <header><div className={"header-title " + (titleColor || "green")}>{title}</div>
            <div className="header-dismiss">
                <div className="icon-btn-cancel" onClick={() => onClose()}></div>
            </div>
        </header>
        <main>{body}</main>
        {
            withPassword ? <form action="" autoComplete="off" method="" onSubmit={onPasswordSubmit}>
                <footer className="password-entry has-separator">
                    <div className="flex-extend">
                        <input ref={passwordRef} autoFocus onInput={onPasswordChange} name="password" className="input password large" placeholder="Type in password" />
                    </div>
                    <div className="flex-shrink">
                        <Button onClick={closeWithPassword} color="green" icon="confirm" disabled={passwordEmpty}>{affirmText}</Button>
                    </div>
                </footer>
            </form>: <footer className="has-separator">{footer}</footer>
        }
        
    </div>;
}

export function ModalWithPassword({ title = "", affirmText = "DONE", hint = ""}) {
    return (<div className="modal">
        <header>
            <div className="header-title green">{title}</div>
            <div className="header-dismiss">
                <div className="icon-btn-cancel"></div>
            </div>
        </header>
        <main></main>
        <footer className="password-entry has-separator">
            <div className="flex-extend"><input name="password" className="input password large" placeholder={hint} /></div>
            <div className="flex-shrink"><button className="btn-confirm green disabled">{affirmText}</button></div>
        </footer>
    </div>)
}